import React, { useState, useEffect } from 'react';
import './WordRichSimple.scss';

export default function WordRichSimple({ fields }) {
  return (
    <div className="WordRichSimpleComp">
      <div
        className="WordRichSimpleCompIn"
        dangerouslySetInnerHTML={{ __html: fields.content?.value }}
      ></div>
    </div>
  );
}
